//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Layout from '@/components/ResponsiveLayout'
import SwoopLogo from '@/components/SwoopLogo'

export default {
  components: {
    Layout,
    SwoopLogo
  }
}
